import React, { Component } from "react";
import { gql } from "@apollo/client";
import FileLarge from "../FileLarge/FileLarge";
import Slider from "react-slick";
import NavArrow from "./NavArrow/NavArrow";
import { getParsedDate } from "../../../helper";
import { apolloClient } from "../../../index";
import { notify } from "../../Notify/Notify";

const maxDisplayItems = 2;

const QUICK_ACCESS_FOLDER = gql`
  query {
    quickAccessFolders(first: 5) {
      id
      title
      isRoot
      color {
        id
      }
      modifiedTs
      parentFolder {
        id
      }
    }
  }
`;

const PINNED_FOLDERS = gql`
  query {
    pinFolders(first: 0, skip: 0) {
      id
      title
      isRoot
      modifiedTs
      color {
        id
      }
      parentFolder {
        id
      }
    }
  }
`;

class FileLargeItems extends Component {
  state = {
    data: [],
    settings: {
      dots: false,
      infinite: false,
      speed: 250,
      arrows: true,
      variableWidth: true,
      adaptiveHeight: true,
      slidesToShow: null,
      slidesToMove: 1,
      nextArrow: <NavArrow arrowValue="next" />,
      prevArrow: <NavArrow arrowValue="prev" />,
    },
  };

  componentDidMount() {
    let recent = this.props.isQuickAccess
      ? QUICK_ACCESS_FOLDER
      : PINNED_FOLDERS;

    apolloClient
      .query({
        query: gql`
          ${recent}
        `,
      })
      .then((result) => {
        const totalItems = this.props.isQuickAccess
          ? result.data.quickAccessFolders.length
          : result.data.pinFolders.length;

        const data = this.props.isQuickAccess
          ? result.data.quickAccessFolders
          : result.data.pinFolders;

        let newSettings = { ...this.state.settings };
        newSettings.slidesToShow =
          totalItems < maxDisplayItems ? totalItems : maxDisplayItems;
        this.setState({
          data: data,
          settings: newSettings,
        });
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.quickAccess !== this.props.quickAccess) {
      if (this.props.isQuickAccess) {
        const updatedData = [...this.state.data];
        updatedData.unshift(this.props.quickAccess);
        this.setState({ data: updatedData });
      }
    } else if (prevProps.recentPinFolder !== this.props.recentPinFolder) {
      if (Object.keys(this.props.recentPinFolder).length > 0) {
        const updatedData = [...this.state.data];
        updatedData.unshift(this.props.recentPinFolder);

        // update slide to show
        let newSettings = { ...this.state.settings };
        newSettings.slidesToShow =
          updatedData.length < maxDisplayItems
            ? updatedData.length
            : maxDisplayItems;

        // update state
        this.setState({ data: updatedData, settings: newSettings });
      } else {
        const updatedData = [...this.state.data];
        const filterData = updatedData.filter(
          (data) => data.id !== this.props.recentPinId
        );

        // update slide to show
        let newSettings = { ...this.state.settings };
        newSettings.slidesToShow =
          updatedData.length - 1 < maxDisplayItems
            ? updatedData.length - 1
            : maxDisplayItems;
        this.setState({ data: filterData, settings: newSettings });
      }
    }
  }

  pinHandler = (id, itemTitle, parentFolder) => {
    const variables = {
      folderId: id,
    };
    apolloClient
      .mutate({
        mutation: gql`
          mutation UnPinFolder($folderId: UUID!) {
            unPinFolder(folderId: $folderId) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let newArr = this.state.data;
        let newSettings = { ...this.state.settings };
        const findIndex = newArr.findIndex((item) => item.id === id);
        if (findIndex > -1) {
          newArr.splice(findIndex, 1);
          newSettings.slidesToShow =
            newArr.length < maxDisplayItems ? newArr.length : maxDisplayItems;
          this.setState({ data: newArr, settings: newSettings });
          const detail = "Success";
          const title = `${itemTitle} unpin successfully!`;
          const type = "success";
          notify(detail, title, type);
        }

        if (parentFolder) {
          const rootFolders = [...this.props.rootFolders];
          const subFolders = { ...this.props.subFolders };
          subFolders[parentFolder.id].map((sub) => {
            if (sub.id === id) {
              sub.pinnedFolder = [];
            }
            return true;
          });
          this.props.updateFolders({
            rootFolders: rootFolders,
            subFolders: subFolders,
          });
        } else {
          const rootFolders = [...this.props.rootFolders];
          const subFolders = { ...this.props.subFolders };
          rootFolders.map((root) => {
            if (root.id === id) {
              root.pinnedFolder = [];
            }
            return true;
          });
          this.props.updateFolders({
            rootFolders: rootFolders,
            subFolders: subFolders,
          });
        }
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  render() {
    return (
      <div className="mt-12">
        <h6 className="bold pl-3">{this.props.itemsTitle}</h6>

        <div className="mt-3">
          <Slider {...this.state.settings}>
            {this.props.isQuickAccess
              ? this.state.data.map((item) => (
                  <FileLarge
                    key={item.id}
                    folderId={item.id}
                    parentFolderId={
                      item.parentFolder && item.parentFolder.id
                        ? item.parentFolder.id
                        : null
                    }
                    item={item}
                    title={item.title}
                    lastOpen={getParsedDate(item.modifiedTs)}
                    color={item.color.id}
                  />
                ))
              : this.state.data.map((item) => (
                  <FileLarge
                    key={item.id}
                    folderId={item.id}
                    parentFolderId={
                      item.parentFolder && item.parentFolder.id
                        ? item.parentFolder.id
                        : null
                    }
                    title={item.title}
                    lastOpen={getParsedDate(item.modifiedTs)}
                    color={item.color.id}
                    pinned={this.props.pinned}
                    pinHandler={() => {
                      this.pinHandler(item.id, item.title, item.parentFolder);
                    }}
                  />
                ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default FileLargeItems;
